import { render, staticRenderFns } from "./GoogleBusinessPageSetupFlow.vue?vue&type=template&id=74751e1f&scoped=true&lang=pug&"
import script from "./GoogleBusinessPageSetupFlow.vue?vue&type=script&lang=js&"
export * from "./GoogleBusinessPageSetupFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74751e1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
